var map = {
	"./MainPage/A-HomeView/Reg.js": 7552,
	"./MainPage/B-AboutView/Reg.js": 4627,
	"./MainPage/C-product/Reg.js": 9563,
	"./MainPage/D-join/Reg.js": 2613,
	"./MainPage/E-contact/Reg.js": 474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5408;